import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const AddProgramRequiredModal = ({ open }) => (
  <Dialog
    open={open}
    onClose={(_event, reason) => {
      if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
    }}
    disableEscapeKeyDown
    maxWidth='sm'
    fullWidth
    aria-labelledby='add-program-required-title'
  >
    <DialogTitle id='add-program-required-title' sx={{ fontWeight: 700 }}>
      Add a Program to continue
    </DialogTitle>
    <DialogContent>
      <DialogContentText sx={{ color: 'text.secondary', lineHeight: 1.6 }}>
        To create your Company Profile, you first need to add at least one Program.
      </DialogContentText>
    </DialogContent>
    <DialogActions sx={{ px: 3, pb: 2.5 }}>
      <Button component={RouterLink} to='/programs' variant='contained' sx={{ textTransform: 'none', fontWeight: 600 }}>
        Go to Programs
      </Button>
    </DialogActions>
  </Dialog>
);

export default AddProgramRequiredModal;
